import $http from './http';
//登录
export function login(params) {
    return $http({
        url: `/xmt/login`,
        params,
        method: 'post'
    });
}
//退出登录
export function logout(params) {
    return $http({
        url: `/xmt/logout`,
        params,
        method: 'post'
    });
}